<template>
  <div>
    <!-- 地图 -->
    <div id="container" ref="container"></div>
  </div>
</template>
<script>
import { bd09ToGcj02, wgs84ToGcj02 } from '../utils/coordConvert.js'

export default {
  name: "TianContainer",
  props: {
    defaultData: {
      type: Array,
      default: () => []
    },
    cityName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tiandituKey: "7e5d35c881919c3fab17e87d55d00d99"
    };
  },
  created() {
    this.T = null;
    this.map = null;
  },
  mounted() {
    this.initAMap();
  },
  unmounted() {
    if (this._wheelHandler && this._wheelContainer) {
      this._wheelContainer.removeEventListener("wheel", this._wheelHandler);
      this._wheelHandler = null;
      this._wheelContainer = null;
    }
    this.map?.destroy();
  },
  watch: {
    cityName(newVal) {
      if (newVal) {
        this.gotoCity(newVal);
      }
    },
    defaultData: {
      deep: true,
      handler(newVal) {
        if (this.T && this.map) {
          this.addOverlay(newVal);
        }
      }
    }
  },
  methods: {
    initAMap() {
      this.$nextTick(() => {
        this.loadTianditu().then((T) => {
          this.T = T;

          this.map = new T.Map("container", {
            projection: "EPSG:4326"
          });

          this.map.centerAndZoom(new T.LngLat(116.4096, 39.90923), 11);

          this.map.addLayer(new T.TileLayer("vec", { tk: this.tiandituKey }));
          this.map.addLayer(new T.TileLayer("cva", { tk: this.tiandituKey }));

          this.map.addControl(new T.Control.Zoom());
          this.map.addControl(new T.Control.Scale());
          this.map.enableScrollWheelZoom();

          this._wheelHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (e.deltaY < 0) {
              this.map.zoomIn();
            } else {
              this.map.zoomOut();
            }
          };
          this._wheelContainer = document.getElementById("container");
          this._wheelContainer.addEventListener("wheel", this._wheelHandler, { passive: false });

          this.addOverlay(this.defaultData);
        })
      })
    },
    clearMap() {
      if (this.map) {
        this.map.clearOverLays();
      }
    },
    addOverlay(array) {
      if (!this.T || !this.map) return;
      this.clearMap()
      for (const item of array) {
        this.addPosition(item)
      }
    },
    removeOverlay(array) {
      const titlesToRemove = array.map(item => item[2]);
      const allOverlays = this.map.getOverlays();
      const toRemove = allOverlays.filter(overlay =>
        titlesToRemove.includes(overlay.options?.title || overlay.getTitle?.())
      );
      toRemove.forEach(o => this.map.removeOverLay(o));
    },
    addPosition(item) {
      if (!this.T || !this.map) return;
      var lng = item[0], lat = item[1];
      if (item[4] === 'BD-09') {
        [lng, lat] = bd09ToGcj02(lng, lat);
      } else if (item[4] === 'WGS-84') {
        var pos = wgs84ToGcj02(lng, lat);
        lng = pos.lon;
        lat = pos.lat;
      }
      // GCJ-02: 天地图原生支持，直接使用坐标
      var latlng = new this.T.LngLat(lng, lat);
      var color = item[3] || '#000';
      var icon = new this.T.DivIcon({
        html: `<div style="color:${color};font-size:13px;background:#fff;border:1px solid #ccc;padding:2px 6px;white-space:nowrap;">${item[2]}</div>`,
        className: 'tian-label-icon',
        iconAnchor: [9, 0],
      });
      var marker = new this.T.Marker(latlng, {
        icon: icon,
        title: item[2]
      });

      this.map.addOverLay(marker);
    },
    loadTianditu() {
      return new Promise((resolve, reject) => {
        if (typeof window.T !== "undefined") {
          resolve(window.T);
          return;
        }

        const script = document.createElement("script");
        script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${this.tiandituKey}`;
        script.onload = () => resolve(window.T);
        script.onerror = (e) => {
          console.error("天地图JS加载失败，请检查密钥和网络", e);
          this.$message?.error?.("地图服务加载失败");
          reject(e);
        };
        document.head.appendChild(script);
      })
    },
    gotoCity(cityName) {
      if (!this.T || !this.map) {
        console.warn('地图未初始化，无法跳转城市');
        return;
      }

      const geocoder = new this.T.Geocoder();
      geocoder.getPoint(cityName, (result) => {
        if (result.getStatus() === 0) {
          const point = result.getLocationPoint();
          this.map.centerAndZoom(point, 12);
        } else {
          console.error(`无法定位城市: ${cityName}`);
        }
      });
    },

  },
};
</script>
<style scoped>
#container {
  width: 100%;
  height: 800px;
}
</style>

<style>
.tian-label-icon {
  width: auto !important;
  height: auto !important;
}
</style>
